// extracted by mini-css-extract-plugin
export var column = "_ts-0";
export var divider = "_ts-2";
export var timePicker = "_ts-1";